import { BaseTabelaPDF, } from '@monorepo-web/pdf-generator';
import { getLayouts } from './layouts';
export default function TabelaInformacoesAdicionaisPDF(props) {
    const { titulo = 'Informações Adicionais', layout = 'default', theme, config, bench } = props;
    const columns = getLayouts(bench)[layout];
    return BaseTabelaPDF(Object.assign(Object.assign({}, props), { titulo,
        columns, tableConfig: {
            minCellHeight: theme.minCellHeightPDF - 1,
            cellWidth: (config === null || config === void 0 ? void 0 : config.col) === 12 ? 140 : 'auto',
        } }));
}
